import React from "react";
import { createRoot } from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import App from "./App";
import "./index.css";

export const GOOGLE_CLIENT_ID =
  "652327064494-6h3e68d7facqrdfgs99obmpe9vtm08m4.apps.googleusercontent.com";

const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

// console.log("Using Google Client ID:", GOOGLE_CLIENT_ID);

root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>,
);
